module.exports = __webpack_public_path__ + "img/3.188a6695.png";